import styled from 'styled-components';
import PlusSvg from 'library/icons/plus.svg';
import Modal from 'library/components/modal';

const Body = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
`;

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  div:last-child {
    border-bottom: unset;
  }
`;

const ButtonRow = styled.div`
  position: sticky;
  position: -webkit-sticky;
  bottom: 0;
  z-index: 1;
  display: flex;
  justify-content: space-around;
  min-height: 40px;
  width: 100%;
  background-color: white;
  border-top: 1px solid ${(props) => props.theme.colors.grey200};

  &&& button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.25em 1em;
    border-radius: 4px;
    font-weight: 600;
    font-size: 14px;
    text-transform: none;
    margin-top: 0.5em;
    min-height: 30px;
    &:focus {
      outline: -webkit-focus-ring-color auto 1px;
      outline-color: -webkit-focus-ring-color;
      outline-style: auto;
      outline-width: 1px;
    }
  }

  @media (max-width: ${(props) => props.theme.screen.tablet}px) {
    padding-top: 0.5em;
    padding-bottom: 1em;

    &&& button {
      margin-bottom: 0.5em;
    }
  }
`;

const ClearButton = styled.button`
  background: ${(props) =>
    props.filtersActive
      ? props.theme.colors.grey300
      : props.theme.colors.grey100};
  border: none;
  color: ${(props) =>
    props.filtersActive
      ? props.theme.colors.grey800
      : props.theme.colors.grey600};
  max-width: 140px;
  width: 35%;
  margin-left: 1.5em;
  margin-bottom: 0.5em;
  ${(props) => (props.isTabbing ? '' : 'outline: none;')}

  &:not(:disabled):hover {
    background: ${(props) =>
      props.filtersActive
        ? props.theme.colors.grey300
        : props.theme.colors.grey100};
    border-color: none;
  }
`;

const ShowButton = styled.button`
  background: ${(props) => props.theme.colors.yellow300};
  border: none;
  color: #134a5e;
  max-width: 205px;
  width: 65%;
  margin-right: 1.5em;
  margin-left: 0.5em;
  margin-bottom: 0.5em;
  ${(props) => (props.isTabbing ? '' : 'outline: none;')}
`;

const StickyHeader = styled.div`
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 1;
  display: flex;
  justify-content: space-around;
  align-items: center;
  min-height: 40px;
  width: 100%;
  background-color: white;

  @media (max-width: ${(props) => props.theme.screen.tablet}px) {
    flex-direction: column;
    padding-top: 1em;
    padding-bottom: 1em;
  }
`;

const CloseIcon = styled(PlusSvg)`
  transform: rotate(45deg);
  ${(props) => (props.isTabbing ? '' : 'outline: none;')}
`;

const StyledModal = styled(Modal)`
  flex-wrap: wrap;
  height: 100%;
  background-color: white;
  overflow: auto;
  ${(props) => (props.isTabbing ? '' : 'outline: none;')}
`;

const HeaderContent = styled.div`
  background-color: white;
  padding: 0 1.5em;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export {
  StyledModal,
  Body,
  Content,
  StickyHeader,
  ButtonRow,
  CloseIcon,
  ShowButton,
  ClearButton,
  HeaderContent,
};
